// src/components/Busqueda/BarraBusqueda.js
import React from 'react';

function BarraBusqueda({ query, setQuery, onSearch, isLoading }) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="input-group mb-3">
      <input
        type="text"
        className="form-control form-control-lg"
        placeholder="Buscar artículo por descripción, marca o modelo..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isLoading}
      />
      <button 
        className="btn btn-primary" 
        type="button" 
        onClick={onSearch}
        disabled={isLoading}
      >
        {isLoading ? 'Buscando...' : 'Buscar'}
      </button>
    </div>
  );
}

export default BarraBusqueda;